import { differenceInDays, intervalToDuration, isBefore, isFuture, isSameDay, set } from "date-fns";
import { ensureDateObject, isValidDate } from "./dates";

export function dueDateClassForTask(task)
{
    const fieldsToReset = {hours: 0, minutes: 0, seconds: 0};
    const dateObj = isValidDate(task.due_date) ? set(ensureDateObject(task.due_date), fieldsToReset) : null;
    const completedObj = isValidDate(task.completed_at) ? ensureDateObject(task.completed_at) : null;
    const now = set(new Date, fieldsToReset);

    // Handle N/A dates and already completed tasks
    if(dateObj == null || completedObj != null)
    {
        return 'due-na';
    }

    // Past due
    if(isBefore(dateObj, now))
    {
        return 'due-past';
    }

    // Due today
    if(isSameDay(dateObj, now))
    {
        return 'due-today';
    }

    // Due soon
    const daysBetween = differenceInDays(dateObj, now);
    if(isFuture(dateObj) && daysBetween <= 7)
    {
        return 'due-soon';
    }

    return 'due-future';
};
